import { DesplegableModel, Paciente } from "../interfaces";

export const transformers = {
  // Convertir array de objetos a DesplegableModel
  toDesplegable: <T extends { codigo: number; nombre: string }>(items: T[], notaKey?: keyof T | string): DesplegableModel[] => {
    return items.map((item) => ({
      codigo: item.codigo,
      text: item.nombre,
      nota: notaKey ? String((item as any)[notaKey]) : undefined,
    }));
  },

  // Transformar respuesta API a Paciente
  toPaciente: (apiData: any): Paciente => ({
    codigo: apiData.codigo ?? 0,
    hc: apiData.hc ?? 0,
    documentoNro: apiData.documentoNro ?? 0,
    documentoTipo: apiData.documentoTipo ?? 0,
    documentoTipoNombre: apiData.documentoTipoNombre ?? "",
    nombre: apiData.nombre ?? "",
    apellido: apiData.apellido ?? "",
    mutual: apiData.mutual ?? 0,
    mutualNombre: apiData.mutualNombre ?? "",
    telefono: apiData.telefono ?? "",
    celular: apiData.celular ?? "",
    email: apiData.email ?? "",
    sexo: apiData.sexo ?? "",
    mutualAfiliado: apiData.mutualAfiliado ?? "",
    nacimiento: apiData.nacimiento ?? "",
    password: apiData.password ?? "",
  }),

  // Formatear número para WhatsApp
  toWhatsAppNumber: (numero: string): string => {
    if (!numero) return "";

    let numeroLimpio = numero.replace(/[\s\-\(\)\+]/g, "");

    if (numeroLimpio.startsWith("0")) {
      numeroLimpio = numeroLimpio.substring(1);
    }

    if (!numeroLimpio.startsWith("54") && numeroLimpio.length <= 10) {
      numeroLimpio = "54" + numeroLimpio;
    }

    return numeroLimpio;
  },
};
